export class ListOfDataListItemResponse {
	description: string;
	name: string;
	value: number;
}
